import { render, staticRenderFns } from "./TegakiCanvas.vue?vue&type=template&id=5110651d&scoped=true&lang=pug"
import script from "./TegakiCanvas.vue?vue&type=script&lang=ts"
export * from "./TegakiCanvas.vue?vue&type=script&lang=ts"
import style0 from "./TegakiCanvas.vue?vue&type=style&index=0&id=5110651d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5110651d",
  null
  
)

export default component.exports